import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, onMounted, onUnmounted } from 'vue'

  import KetchUpButton from '@/components/common/KetchUpButton.vue'
  import SVGRenderer from '@/components/common/SVGRenderer.vue'

  import { useRoute } from 'vue-router/composables'
  import useIcons from '@/composables/useIcons'
  import useEditor from '@/composables/useEditor'

  import { EditorModule } from '@/store/modules/editor'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'EditorButtons',
  props: {
    path: String,
    hideSaveDiscardButtons: {
      type: Boolean,
      default: false,
    },
  },
  setup(__props) {

const props = __props;

  

  const route = useRoute()
  const { undoIcon, checkmark, closeIcon } = useIcons()
  const { hasChanges, saveAllChanges, discardAllChanges } = useEditor(route)

  const canUndo = computed(() => EditorModule.canUndo(props.path || route.path))
  const canRedo = computed(() => EditorModule.canRedo(props.path || route.path))

  const onUndoClick = () => {
    EditorModule.undo(props.path || route.path)
  }
  const onRedoClick = () => {
    EditorModule.redo(props.path || route.path)
  }

  const hasEditButtons = computed(() => {
    return EditorModule.editMode && hasChanges.value
  })

  const isSticky = ref(false)
  const wrapperRef = ref<HTMLElement | null>(null)

  const checkStickyState = () => {
    if (!wrapperRef.value) return

    const rect = wrapperRef.value.getBoundingClientRect()
    const computedStyle = window.getComputedStyle(wrapperRef.value)
    const topValue = parseFloat(computedStyle.top) || 0

    isSticky.value = rect.top <= topValue
  }

  onMounted(() => {
    window.addEventListener('scroll', checkStickyState, { passive: true })
    checkStickyState()
  })

  onUnmounted(() => {
    window.removeEventListener('scroll', checkStickyState)
  })

return { __sfc: true,props, route, undoIcon, checkmark, closeIcon, hasChanges, saveAllChanges, discardAllChanges, canUndo, canRedo, onUndoClick, onRedoClick, hasEditButtons, isSticky, wrapperRef, checkStickyState, computed, ref, onMounted, onUnmounted, KetchUpButton, SVGRenderer, useRoute, useIcons, useEditor, EditorModule }
}

})